import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type BarChartOffProps = IconComponentBaseProps;

export const BarChartOff = ({
  className,
  width = 16,
  height = 16,
  fill = defaultTheme.mantineColors.gray[7],
}: BarChartOffProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
    >
      <mask
        id="mask0_5052_105373"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5052_105373)">
        <path
          d="M3.60253 12.9999C3.43175 12.9999 3.28864 12.9422 3.1732 12.8266C3.05764 12.7112 2.99987 12.568 2.99987 12.3973V6.87476C2.99987 6.70098 3.05764 6.5566 3.1732 6.4416C3.28864 6.32671 3.43175 6.26926 3.60253 6.26926H4.7307C4.90137 6.26926 5.04448 6.32698 5.16003 6.44243C5.27548 6.55787 5.3332 6.70098 5.3332 6.87176V12.3943C5.3332 12.5682 5.27548 12.7125 5.16003 12.8274C5.04448 12.9424 4.90137 12.9999 4.7307 12.9999H3.60253ZM7.4357 12.9999C7.26503 12.9999 7.12192 12.9422 7.00637 12.8266C6.89092 12.7112 6.8332 12.568 6.8332 12.3973V6.83326L9.16653 9.1666V12.3973C9.16653 12.568 9.10881 12.7112 8.99337 12.8266C8.87781 12.9422 8.7347 12.9999 8.56403 12.9999H7.4357ZM9.16653 7.27943L6.8332 4.9461V3.6026C6.8332 3.43182 6.89092 3.28871 7.00637 3.17326C7.12192 3.05771 7.26503 2.99993 7.4357 2.99993H8.56403C8.7347 2.99993 8.87781 3.05771 8.99337 3.17326C9.10881 3.28871 9.16653 3.43182 9.16653 3.6026V7.27943ZM12.9999 11.1128L11.0127 9.1256V9.0641H12.3972C12.568 9.0641 12.7111 9.12182 12.8265 9.23726C12.9421 9.35282 12.9999 9.49593 12.9999 9.6666V11.1128ZM12.8512 14.2666L1.72303 3.1486C1.62381 3.04948 1.57487 2.93176 1.5762 2.79543C1.57742 2.6591 1.62975 2.53921 1.7332 2.43576C1.83664 2.33243 1.95548 2.28076 2.0897 2.28076C2.22381 2.28076 2.34259 2.33243 2.44603 2.43576L13.564 13.5641C13.6631 13.6632 13.7138 13.7792 13.7159 13.9121C13.718 14.045 13.6674 14.1632 13.564 14.2666C13.4606 14.37 13.3418 14.4218 13.2075 14.4218C13.0734 14.4218 12.9546 14.37 12.8512 14.2666Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
